import request from 'superagent'

import {citiesApi} from '@/modules/ITSM/api/generate-itsm-api-url'

export const fetchCities = async country =>
  request.post(citiesApi().cities).send({country})
